import Cookies from 'js-cookie';

export const getToken = () => JSON.parse(localStorage.getItem('okta-token-storage')).accessToken
  .accessToken;
export const isInternalUser = Cookies.get('isInternal');
